// extracted by mini-css-extract-plugin
export default {"pointsTable":"PointsTableTooltip_pointsTable__-5SM+"};